import { render, staticRenderFns } from "./rightSide.vue?vue&type=template&id=78885b30&scoped=true&"
import script from "./rightSide.vue?vue&type=script&lang=js&"
export * from "./rightSide.vue?vue&type=script&lang=js&"
import style0 from "./rightSide.vue?vue&type=style&index=0&id=78885b30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78885b30",
  null
  
)

export default component.exports